// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"23":"interaction-areas","53":"dash","311":"recommendations-overlay","386":"styled-text-tracks","436":"chapters","449":"playlist","698":"ima","961":"defaultProfiles","990":"shoppable"}[chunkId] + ".min.js";
};